import {defaultFont} from '../../styles/style';

const style = {
  form: {
    marginTop: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  form__error: {
    ...defaultFont,
    fontSize: '14px',
  },
};

export default style;
